// extracted by mini-css-extract-plugin
export default {"checkout_summary":"LC","checkout_summary_wrapper":"MC","summary_items":"NC","line_items_wrapper":"OC","separator":"PC","order_summary":"QC","line_item":"RC","order__summary_item_title":"SC","recurringdis":"TC","note":"UC","carbon_emission":"VC","unlock_savings":"WC","member_perk":"XC","info":"YC","no_items":"ZC","promo":"aE","order_summary_mobile":"bE","open_summary_mobile":"cE","fixed_bottom_info":"eE","open_info":"fE","text":"gE","open_summary":"hE"};
    if(module.hot) {
      // 1721922364194
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  